import React, { useEffect, useState } from "react";
import { Image, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addOthersApi, editOthersApi } from "../../../../services/AdminService";
import { useAuth } from "../../../../contexts/AuthProvider";
import othersIcon from "../../../../assets/images/others-icon.png";
import MultipleImage from "../../../../components/multi-img/MultipleImage";
import {
  CostInputField,
  DateTimeField,
  LocationInputField,
  SelectDropDownField,
  TextAreaInputField,
  TextInputField,
} from "../../../../components/form-fields";
import AddressSelector from "../../../../components/search-location/AddressSelector";
import moment from "moment";
import { getFirstDayAndLastDay } from "../../../../helpers";
import { LoadingSpinnerDotted } from "../../../../components/loading-spinner/Loader";

function OthersModal({
  showOtherModal,
  setShowOtherModal,
  dayData,
  returnFunction,
  destinationData,
  editable,
  itemData,
}) {
  const { authed, currencyData } = useAuth();
  // Start of Other functions
  const [showSelectMapModal, setShowSelectMapModal] = useState(false);
  const [otherAvatarImg, setOtherAvatarImg] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const handleSelectAddress = (results) => {
    // console.log("Selected Address:", results);
    const { address, lat, lng } = results;
    formik.setFieldValue("address", {
      formatted_address: address,
      lat: lat,
      lng: lng,
    });
  };
  const formik = useFormik({
    initialValues: {
      name: itemData?.name || "",
      address: {
        formatted_address: itemData?.address || "",
        lat: itemData?.location?.coordinates[0] || "",
        lng: itemData?.location?.coordinates[1] || "",
      },
      otherType: itemData?.types[0] || "",
      amount: itemData?.amount || "",
      time: itemData?.time || "",
      currency: editable
        ? itemData?.currency
        : currencyData
          ? currencyData?.currency
          : "",
      fromDate: editable
        ? moment(itemData.from_date).toDate()
        : dayData
          ? moment(dayData?.date).toDate()
          : "",
      toDate: editable ? moment(itemData.to_date).toDate() : dayData ? moment(dayData?.date).toDate() : "",
      description: itemData?.description || "",
      websiteLink: itemData?.websiteLink || "",
      status: itemData?.status || "Not Booked",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name."),
      address: Yup.object({
        formatted_address: Yup.string().required("Please enter a location."),
      }),
      amount: Yup.string().required("Please enter your expenses."),
      otherType: Yup.string().required("Please enter type."),
      fromDate: Yup.string().required("Please enter date & time."),
      toDate: Yup.string().required("Please enter date & time.").test(
        "is-greater-time",
        "Check-out time must be after check-in time if on the same day.",
        function (value) {
          const { fromDate, toDate } = this.parent;
          if (!fromDate || !value) return true;
          const checkFromTime = moment(fromDate);
          const checkToTime = moment(toDate);
          if (checkFromTime.isSame(checkToTime, "day")) {
            return checkToTime.isAfter(checkFromTime);
          }
          return true;
        }
      ),
      websiteLink: Yup.string()
        .matches(
          /^https:\/\//, "URL must start with https://"
        ).nullable(),
    }),
    onSubmit: async (values) => {
      // console.log(values);
      const formData = new FormData();
      if (otherAvatarImg.length > 0) {
        otherAvatarImg.forEach((item) => formData.append("icon", item));
      } else {
        if (!editable) formData.append("icon", null);
      }
      formData.append("name", values.name);
      formData.append("address", values.address.formatted_address);
      formData.append("lat", values.address.lat);
      formData.append("lng", values.address.lng);
      formData.append("description", values.description);
      formData.append("amount", values.amount);
      formData.append("currency", values.currency);
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("time", moment(values.fromDate).format("HH:mm"));
      formData.append("userId", authed.user._id);
      formData.append("itineraryId", dayData.itineraryId);
      formData.append("daysId", dayData._id);

      formData.append("types", values.otherType);
      formData.append("websiteLink", values.websiteLink);

      formData.append("status", values.status);

      setIsLoadingSubmit(true);
      if (editable) {
        formData.append("uniqueIdDayWise", itemData?.uniqueIdDayWise);
        await editOthersApi(formData, (res) => {
          if (res.status === 200) {
            // console.log("Success: Data added", res.data);
            setOtherAvatarImg([]);
            setShowOtherModal(false);
            formik.resetForm();
            returnFunction();
          } else {
            console.log(
              `Error: ${res.data?.message || "An unexpected error occurred."}`
            );
          }
          setIsLoadingSubmit(false);
        });
      } else {
        await addOthersApi(formData, (res) => {
          if (res.status === 200) {
            // console.log("Success: Data added", res.data);
            setOtherAvatarImg([]);
            setShowOtherModal(false);
            formik.resetForm();
            returnFunction();
          } else {
            console.log(
              `Error: ${res.data?.message || "An unexpected error occurred."}`
            );
          }
          setIsLoadingSubmit(false);
        });
      }
    },
  });

  const handleOtherModalClose = () => {
    setOtherAvatarImg([]);
    setShowOtherModal(false);
    formik.resetForm();
    setIsLoadingSubmit(false);
  };
  // end of Other functions

  useEffect(() => { }, [dayData?.date]);
  useEffect(() => {
    if (itemData) {
      setOtherAvatarImg(itemData?.icon);
    }
  }, [itemData]);

  // console.log("=====itemData=======>", editable, itemData);
  // console.log("=====destinationData=======>", destinationData);
  return (
    <>
      <Modal
        show={showOtherModal}
        onHide={handleOtherModalClose}
        keyboard={false}
        size="lg"
        className="add-travellers-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Image src={othersIcon} width={16} />
            Other
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <MultipleImage
                  imageList={otherAvatarImg}
                  setImageList={setOtherAvatarImg}
                />
              </div>
              <div className="col-md-6 mb-3">
                <TextInputField
                  formik={formik}
                  fieldName="name"
                  labelName="Name"
                  placeHolder="Enter Name"
                />
              </div>
              <div className="col-md-6 mb-3">
                <TextInputField
                  formik={formik}
                  fieldName="otherType"
                  labelName="Type"
                  placeHolder="Enter Type"
                />
              </div>

              <div
                className="col-md-12 mb-3"
                onClick={() => {
                  setShowSelectMapModal(true);
                }}
              >
                <LocationInputField
                  formik={formik}
                  objName={"address"}
                  fieldName={"formatted_address"}
                  labelName={"Address"}
                  placeHolder={"Select a location"}
                  disabled={true}
                />
              </div>

              <div className="col-md-6 mb-3">
                <DateTimeField
                  formik={formik}
                  fieldName="fromDate"
                  labelName={"From date & time"}
                  minDate={dayData?.date}
                  disabled={editable}
                  maxDate={
                    getFirstDayAndLastDay(destinationData?.itineraryDatys)
                      ?.lastDate
                  }
                  type="from"
                />
              </div>
              <div className="col-md-6 mb-3">
                <DateTimeField
                  formik={formik}
                  fieldName="toDate"
                  labelName={"To date & time"}
                  minDate={dayData?.date}
                  disabled={editable}
                  type={editable ? "to" : false}
                  maxDate={
                    getFirstDayAndLastDay(destinationData?.itineraryDatys)
                      ?.lastDate
                  }
                />
              </div>

              <div className="col-md-6 mb-3">
                <CostInputField
                  formik={formik}
                  fieldName="amount"
                  labelName="Estimated Cost (Per Day)"
                  currency={currencyData}
                  placeHolder="Enter Cost"
                />
              </div>
              <div className="col-md-6 mb-3">
                <SelectDropDownField
                  formik={formik}
                  fieldName="status"
                  labelName="Status"
                  options={["Not Booked", "Booked"]}
                />
              </div>

              <div className="col-md-12 mb-3">
                <TextInputField
                  formik={formik}
                  fieldName="websiteLink"
                  labelName="Website URL"
                  placeHolder="Enter Website URL"
                />
              </div>

              <div className="col-md-12">
                <TextAreaInputField
                  formik={formik}
                  fieldName="description"
                  labelName="Description"
                  placeHolder="Enter description"
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="pt-2 pb-2 justify-content-center">
          <button
            type="button"
            onClick={handleOtherModalClose}
            className="btn btn-secondary-color btn-border-color me-0"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={(e) => formik.handleSubmit()}
            className="btn btn-primary-color btn-border-color ms-3"
            disabled={isLoadingSubmit === true}
          >
            {isLoadingSubmit ? <LoadingSpinnerDotted /> : "Submit"}
          </button>
        </Modal.Footer>
      </Modal>
      <AddressSelector
        showModal={showSelectMapModal}
        setShowModal={setShowSelectMapModal}
        addressData={formik.values.address}
        onSelectAddress={(address) => handleSelectAddress(address)}
        destination={destinationData?.destination_city}
      />
    </>
  );
}

export default OthersModal;
